import { HslAdjustmentFilter as PixiHslAdjustmentFilter } from 'pixi-filters';
import { assertNumberBetween } from '../../validators';
import { Config } from '../../video-data/config';
import type { BaseSettings } from '../TimeAwareBase';
import { Filter } from './Filter';

export class HslAdjustmentFilter extends Filter {
    override _classType = Config.HSL_ADJUSTMENT_FILTER;
    override pixiFilter: PixiHslAdjustmentFilter;

    constructor(settings: BaseSettings) {
        super(settings);
        this.pixiFilter = new PixiHslAdjustmentFilter();
    }

    override get propertiesToSerialize() {
        return super.propertiesToSerialize.concat(['hue', 'lightness', 'saturation']);
    }

    /**
     * Hue (-180 to 180)
     */
    get hue(): number {
        return this.pixiFilter.hue;
    }

    set hue(value: number) {
        if (value === this.hue) {
            return;
        }
        assertNumberBetween(value, -180, 180);
        this.pixiFilter.hue = value;
        this.requiresUpdate = true;
    }

    /**
     * Lightness (-1 to 1)
     */
    get lightness(): number {
        return this.pixiFilter.lightness;
    }

    set lightness(value: number) {
        if (value === this.lightness) {
            return;
        }
        assertNumberBetween(value, -1, 1);
        this.pixiFilter.lightness = value;
        this.requiresUpdate = true;
    }

    /**
     * Saturation (-1 to 1)
     */
    get saturation(): number {
        return this.pixiFilter.saturation;
    }

    set saturation(value: number) {
        if (value === this.saturation) {
            return;
        }
        assertNumberBetween(value, -1, 1);
        this.pixiFilter.saturation = value;
        this.requiresUpdate = true;
    }
}
